export enum PageTypes {
  ADP = 'pageAdvice',
  ALP = 'pageAdviceListing',
  ALL = 'pageAllProduct',
  CUSTOM_ALL_ADVICES = 'customAllAdvices',
  BASIC = 'pageBasic',
  EODP = 'pageProductInformations',
  EOLP = 'pageProductInformationsListingPage',
  CATEGORY = 'pageGenericCategory',
  PDP = 'pageProduct',
  PLP = 'pageProductListingPage',
  RDP = 'pageRecipe',
  RLP = 'pageRecipeList',
  SUR = 'survey',
  GSUR = 'genericSurvey',
  SRE = 'surveyResults',
  GSRE = 'genericSurveyResults',
  CONTACT = 'contact',
  THX = 'thankYouPage',
  RESET_PASSWORD = 'resetPassword',
  INVOICE = 'invoice',
  ADYEN_REDIRECT = 'adyenRedirectBack',
  KNOWLEDGE = 'pageKnowledgeBase',
}

export const HARD_CODED_SLUGS = {
  ALL: {
    fr: '/tous-nos-produits',
    it: '/tutti-nostri-prodotti',
    en: '/all-our-products',
    de: '/alle-unsere-produkte',
    es: '/todos-nuestros-productos',
  },
  CONTACT: {
    fr: '/info/contactez-notre-service-client-ou-nos-experts',
    it: '/info/contattare-il-servizio-clienti',
    en: '/info/contact-us',
    de: '/info/kontaktiere-uns',
    es: '/info/atencion-al-cliente',
  },
  CUSTOM_ALL_ADVICES: {
    fr: '/tous-nos-conseils',
    it: '/tutti-i-nostri-consigli',
    en: '/all-our-advices',
    de: '/alle-unsere-tipps',
    es: '/todos-nuestros-consejos',
  },
};

export const getPagePaths = (acceptLanguages: string[], type: PageTypes): { [key: string]: string } => {
  function slugForAllLanguages(path, except = {}) {
    return Object.fromEntries(acceptLanguages.map((lang) => [lang, except[lang] ?? path]));
  }

  switch (type) {
    case PageTypes.ADP:
      return slugForAllLanguages('/page/:slug');
    case PageTypes.ALP:
      return slugForAllLanguages('/pages/:slug');
    case PageTypes.ALL:
      return HARD_CODED_SLUGS.ALL;
    case PageTypes.BASIC:
      return slugForAllLanguages('/content/:slug');
    case PageTypes.EODP:
      return slugForAllLanguages('/guide/:slug', {
        fr: '/info/fiche-technique/:slug',
      });
    case PageTypes.EOLP:
      return slugForAllLanguages('/guides', {
        fr: '/info/guide-des-huiles-essentielles/tous',
      });
    case PageTypes.CATEGORY:
      return slugForAllLanguages('/category/:slug');
    case PageTypes.PDP:
      return slugForAllLanguages('/product/:slug', {
        fr: '/info/fiche-technique/:slug',
      });
    case PageTypes.PLP:
      return slugForAllLanguages('/products/:slug');
    case PageTypes.RDP:
      return slugForAllLanguages('/recipe/:slug');
    case PageTypes.RLP:
      return slugForAllLanguages('/recipes/:slug');
    case PageTypes.SUR:
      return slugForAllLanguages('/survey');
    case PageTypes.GSUR:
      return slugForAllLanguages('/survey/:slug');
    case PageTypes.SRE:
      return slugForAllLanguages('/surveyresults/skincare');
    case PageTypes.GSRE:
      return slugForAllLanguages('/surveyresults/:slug');
    case PageTypes.CONTACT:
      return HARD_CODED_SLUGS.CONTACT;
    case PageTypes.THX:
      return slugForAllLanguages('/checkout/thank-you');
    case PageTypes.RESET_PASSWORD:
      return slugForAllLanguages('/reset-password');
    case PageTypes.INVOICE:
      return slugForAllLanguages('/invoice/:id');
    case PageTypes.ADYEN_REDIRECT:
      return slugForAllLanguages('/adyen-redirect-back');
    case PageTypes.KNOWLEDGE:
      return slugForAllLanguages('/info/base-de-connaissance');
    case PageTypes.CUSTOM_ALL_ADVICES:
      return HARD_CODED_SLUGS.CUSTOM_ALL_ADVICES;
    default:
      return slugForAllLanguages('/');
  }
};
